module.exports = __webpack_public_path__ + "img/logo-header.dc580955.png";